import { render } from "./managemodal.vue?vue&type=template&id=087e2be1"
import script from "./managemodal.vue?vue&type=script&lang=js"
export * from "./managemodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__